import React from 'react';
import AppRoutes from './app/routes/routes';
import { AuthProvider } from './app/context/AuthContext';
import DataProvider from './app/context/DataContext';
import { ToastContainer } from 'react-toastify';

import { useClarityPageView } from './app/utlis/useClarityPageView'; // adjust path if needed

function App() {
  useClarityPageView();

  return (
    <div className='text-white relative'>
      <AuthProvider>
        <DataProvider>
          <AppRoutes />
          <ToastContainer />
        </DataProvider>
      </AuthProvider>
    </div>
  );
}

export default App;